import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { ScrollToTop } from "./components/ScrollToTop";
import { CookieBanner } from "./components/CookieBanner";
import { HomePage } from "./pages/HomePage";
import { BusinessPage } from "./pages/BusinessPage";
import { PersonalPage } from "./pages/PersonalPage";
import { AuthProvider } from "./contexts/AuthContext";
import { SiteContentProvider } from "./contexts/SiteContentContext";
import { ProtectedRoute } from "./components/admin/ProtectedRoute";
import LoginPage from "./pages/admin/LoginPage";
import DashboardPage from "./pages/admin/DashboardPage";
import ContentEditorPage from "./pages/admin/ContentEditorPage";
import InquiriesPage from "./pages/admin/InquiriesPage";
import OrdersPage from "./pages/admin/OrdersPage";
import WaitlistPage from "./pages/admin/WaitlistPage";
import AdminEventsPage from "./pages/admin/AdminEventsPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsPage from "./pages/TermsPage";
import { EventsPage } from "./pages/EventsPage";

function App() {
  return (
    <HelmetProvider>
    <div className="App min-h-screen flex flex-col">
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            {/* Public site */}
            <Route path="/" element={<SiteContentProvider><Header /><div className="flex-1"><HomePage /></div><Footer /></SiteContentProvider>} />
            <Route path="/business" element={<SiteContentProvider><Header /><div className="flex-1"><BusinessPage /></div><Footer /></SiteContentProvider>} />
            <Route path="/personal" element={<SiteContentProvider><Header /><div className="flex-1"><PersonalPage /></div><Footer /></SiteContentProvider>} />
            <Route path="/events" element={<SiteContentProvider><Header /><div className="flex-1"><EventsPage /></div><Footer /></SiteContentProvider>} />
            <Route path="/privacy" element={<SiteContentProvider><Header /><div className="flex-1"><PrivacyPolicyPage /></div><Footer /></SiteContentProvider>} />
            <Route path="/terms" element={<SiteContentProvider><Header /><div className="flex-1"><TermsPage /></div><Footer /></SiteContentProvider>} />

            {/* Admin */}
            <Route path="/admin/login" element={<LoginPage />} />
            <Route path="/admin" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
            <Route path="/admin/content" element={<ProtectedRoute><ContentEditorPage /></ProtectedRoute>} />
            <Route path="/admin/inquiries" element={<ProtectedRoute><InquiriesPage /></ProtectedRoute>} />
            <Route path="/admin/orders" element={<ProtectedRoute><OrdersPage /></ProtectedRoute>} />
            <Route path="/admin/waitlist" element={<ProtectedRoute><WaitlistPage /></ProtectedRoute>} />
            <Route path="/admin/events" element={<ProtectedRoute><AdminEventsPage /></ProtectedRoute>} />
          </Routes>
          <CookieBanner />
        </BrowserRouter>
      </AuthProvider>
    </div>
    </HelmetProvider>
  );
}

export default App;
